module.exports = __webpack_public_path__ + "img/business.c1b36b26.png";